import { Link } from "gatsby";
import React, { useState } from "react";
import ServiceLayout from "../components/service-page-layout";
import MainBanner from "../components/home-page/home-page-main-banner";
import StickySubmenu from "../components/service-landing/service-landing-page-sticky-submenu";
import GridLayout from "../components/common/templates/grid-layout-center-section";
import TwoColumnImageText from "../components/common/templates/two-column-image-text";
import FourColumnLayout from "../components/common/templates/four-column-layout";
import TwoColumnTextImage from "../components/common/templates/two-column-text-image";
import ColumnLayoutLanding from "../components/common/templates/column-layout-landing";
import TwoRowTextImage from "../components/common/templates/two-row-text-image";
import SEO from '../components/seo';
import StickyCTABlock from "../components/common/templates/sticky-cta-section";
import {
  mainBannerObj, gridlayoutstrategyObj, twoColumnImageTextObj, fourcolumnLayoutObj,
  twoColumnTextImageObj, columnLayoutLandingObj, twoRowTextImageObj
} from '../components/service-page/service-page-constants';
import scrollTo from 'gatsby-plugin-smoothscroll';
import { motion, AnimatePresence } from "framer-motion";
import InView from "react-intersection-observer";

function ServicePage(props) {
  const [showVerticalNav, setShowVerticleNav] = useState(true);
  const [showMore, setShowMore] = useState(false);
  
  const handleShowMore = () => {
    setShowMore(!showMore);
  };
  let moreItems = [];
  moreItems.push(
    {
      label: "Data Analytics",
      link: "#analytics"
    },
    {
      label: "Digital Transformation",
      link: "#transformation"
    },
    {
      label: "Hire us!",
      link: "#hire"
    },
    {
      label: "Say Hello",
      link: "#form"
    });

  const verticleNav = (
    <ul className="col vertical-navigation-list text-right">
      <li>
        <Link to="/">Home</Link>
      </li>
      <li>
        <div style={{ color: "#888888", cursor: "pointer" }} onClick={() => scrollTo('#strategy')}>Digital Strategy</div>
      </li>
      <li>
        <div style={{ color: "#888888", cursor: "pointer" }} onClick={() => scrollTo('#experience')}>Digital Experience</div>
      </li>
      <li>
        <div style={{ color: "#888888", cursor: "pointer" }} onClick={() => scrollTo('#software')}> Powerful Software </div>
      </li>
      {!showMore && <li>
        <div style={{ color: "#888888", cursor: "pointer" }} onClick={handleShowMore}>More +</div>
      </li>}
      <AnimatePresence initial={false}>
        {
          showMore &&
          <motion.section
            key="content"
            initial="collapsed"
            animate="open"
            exit="collapsed"
            variants={{
              open: { height: "auto", opacity: 1, x: 0 },
              collapsed: { height: 0, opacity: 0, x: 10 }
            }}
            transition={{
              duration: 1.2,
              ease: [0.04, 0.62, 0.23, 0.98],
              staggerChildren: 0.05,
              delayChildren: 0.05,
            }}>
            {
              moreItems.map((item, key) => {
                return <motion.li key={key}
                  variants={{
                    open: { height: "auto", opacity: 1, x: 0 },
                    collapsed: { height: 0, opacity: 0, x: 10 }
                  }}
                >
                  <div style={{ color: "#888888", cursor: "pointer" }} onClick={() => scrollTo(item.link)}>{item.label}</div>
                </motion.li>;
              })
            }
            <motion.li
              //variants={{ collapsed: { x: 10 }, open: { x: 0 } }}
              transition={{ duration: 0.8, type: "spring" }}>
              <div style={{ color: "#888888", cursor: "pointer" }} onClick={handleShowMore}>Less -</div>
            </motion.li>
          </motion.section>

        }
      </AnimatePresence>
    </ul>
  );

  return (
    <ServiceLayout addBodyClass={"service-page-template transparent-header " + (showVerticalNav ? 'verticle-navigation-active' : '')}
      footerFormType="basic" verticleNav={verticleNav}>

      <SEO description="Rapidops offer a wide range of design and development services for web and mobile apps from enterprise clouds to IoTs to custom business software solutions."
        meta={[{ name: "charSet", content: "utf-8" }]}
        title={`Digital Product Developers Charlotte, Web Design & Development Agency`} />
      
      <MainBanner data={mainBannerObj} setShowVerticleNav={setShowVerticleNav} />
      
      <StickySubmenu />

      <InView onChange={(inView)=>{if(inView){document.getElementById("service-strategy").classList.add("active")}else{document.getElementById("service-strategy").classList.remove("active")}}} threshold={[0.4]}>
        <GridLayout data={gridlayoutstrategyObj} setShowVerticleNav={setShowVerticleNav} id="strategy" />
      </InView>

      <InView onChange={(inView)=>{if(inView){document.getElementById("service-experience").classList.add("active")}else{document.getElementById("service-experience").classList.remove("active")}}} threshold={[0.4]}>
        <TwoColumnImageText data={twoColumnImageTextObj} id="experience" />
      </InView>

      <InView onChange={(inView)=>{if(inView){document.getElementById("service-software").classList.add("active")}else{document.getElementById("service-software").classList.remove("active")}}} threshold={[0.4]}>
        <FourColumnLayout data={fourcolumnLayoutObj} id="software" />
      </InView>

      <InView onChange={(inView)=>{if(inView){document.getElementById("service-analytics").classList.add("active")}else{document.getElementById("service-analytics").classList.remove("active")}}} threshold={[0.4]}>
        <TwoColumnTextImage data={twoColumnTextImageObj} id="analytics" />
      </InView>

      <InView onChange={(inView)=>{if(inView){document.getElementById("service-transformation").classList.add("active")}else{document.getElementById("service-transformation").classList.remove("active")}}} threshold={[0.4]}>
        <ColumnLayoutLanding data={columnLayoutLandingObj} id='transformation' />
      </InView>

      <TwoRowTextImage data={twoRowTextImageObj}/>

      <StickyCTABlock pathname={props.location.pathname} />

    </ServiceLayout>
  );
}

export default ServicePage;
